"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultChartStateTransactionByPriceRange = exports.defaultChartStatePriceRange = exports.defaultChartStateAmount = exports.defaultChartStatePrice = exports.defaultChartAmountState2 = exports.defaultChartAmountState1 = exports.defaultChartTransactionPriceRangeState1 = exports.defaultChartPriceRangeState1 = exports.defaultChartPriceState3Empty = exports.defaultChartPriceState3 = exports.defaultChartPriceState2Empty = exports.defaultChartPriceState2 = exports.defaultChartPriceState1Empty = exports.defaultChartPriceState1 = void 0;
var ChartRangeType_1 = require("@/pages/chart/states/ChartRangeType");
exports.defaultChartPriceState1 = {
    yearType: ChartRangeType_1.ChartRangeType.THREE,
    title: '3 Years',
    yTitle: 'Price / sqft.',
    xTitle: '',
    currentX: -1,
    active: true,
    xLabels: [
        '01/2016', '02/2016', '03/2016',
        '04/2016', '05/2016', '06/2016',
        '07/2016', '08/2016', '09/2016',
        '10/2016', '11/2016', '12/2016',
        '01/2017', '02/2017', '03/2017',
        '04/2017', '05/2017', '06/2017',
        '07/2017', '08/2017', '09/2017',
        '10/2017', '11/2017', '12/2017',
        '01/2018', '02/2018', '03/2018',
        '04/2018', '05/2018', '06/2018',
        '07/2018', '08/2018', '09/2018',
        '10/2018', '11/2018', '12/2018',
    ],
    yLabels: ['Victoria Court'],
    yColors: ['green'],
    yLineColors: ['green'],
    yValues: [
        [
            12013, 11330, 11437,
            12005, 12022, 12791,
            13222, 12745, 12561,
            13111, 12207, 12414,
            12447, 12232, 12553,
            12243, 12574, 12486,
            13041, 13091, 12271,
            13011, 13051, 14027,
            14202, 13897, 14010,
            14250, 15248, 15095,
            15068, 15487, 14670,
            14670, 16000, 15477,
        ],
    ],
    yCountColor: ['#999'],
    yCountColor2: ['green'],
    yCountTitle: ['No. of Transactions'],
    yTextColors: ['red'],
    yCounts: [[3, 8, 6, 8, 5, 7, 1, 0, 1, 3, 10, 4, 7, 5, 3, 10, 9, 8, 2, 5, 2, 3, 5, 5, 1, 7, 10, 4, 4, 7, 4, 7, 6, 9, 9, 10]],
    isError: false,
    isLoaded: true
};
exports.defaultChartPriceState1Empty = {
    yearType: ChartRangeType_1.ChartRangeType.THREE,
    title: '3 Years',
    yTitle: 'Price / sqft.',
    xTitle: '',
    currentX: -1,
    active: true,
    xLabels: [],
    yLabels: [],
    yColors: [],
    yLineColors: [],
    yValues: [],
    yCountColor: [],
    yCountColor2: [],
    yCountTitle: [],
    yTextColors: [],
    yCounts: [],
    isError: false,
    isLoaded: false
};
exports.defaultChartPriceState2 = {
    yearType: ChartRangeType_1.ChartRangeType.TEN,
    title: '10 Years',
    yTitle: 'Price / sqft.',
    xTitle: '',
    currentX: -1,
    active: false,
    xLabels: [
        '01/2012', '01/2014', '01/2015',
        '01/2016', '01/2017', '01/2018',
        '01/2019', '01/2020', '01/2021',
        '01/2022'
    ],
    yLabels: ["Lobster Bay*", "Clearwater Bay", "New Territories"],
    yColors: ["#58b294", "#b61229", "#4971C5"],
    yLineColors: ["#b61229", "#4971C5"],
    yValues: [
        [
            12013, 12022, 12574,
            12745, 12791, 13051,
            13222, 15048, 15287,
            15400
        ],
        [
            12013, 12745, 12574,
            13051, 12022, 12791,
            13222, 15248, 15487,
            16000
        ]
    ],
    yTextColors: ['grey', 'black', 'black'],
    yCountColor: ["#b6122955"],
    yCountColor2: ["#b61229"],
    yCountTitle: ['No. of Transactions'],
    yCounts: [[10, 9, 8, 2, 5, 2, 3, 5, 5, 1]],
    isError: false,
    isLoaded: true
};
exports.defaultChartPriceState2Empty = {
    yearType: ChartRangeType_1.ChartRangeType.TEN,
    title: '10 Years',
    yTitle: 'Price / sqft.',
    xTitle: '',
    currentX: -1,
    active: false,
    xLabels: [],
    yLabels: [],
    yColors: [],
    yLineColors: [],
    yValues: [],
    yTextColors: [],
    yCountColor: [],
    yCountColor2: [],
    yCountTitle: [],
    yCounts: [],
    isError: false,
    isLoaded: false
};
exports.defaultChartPriceState3 = {
    yearType: ChartRangeType_1.ChartRangeType.CUSTOM,
    title: 'Custom',
    yTitle: 'Price / sqft.',
    xTitle: '',
    currentX: -1,
    active: false,
    xLabels: [
        '01/2012', '01/2014', '01/2015',
    ],
    yLabels: ['my district', 'by building'],
    yColors: ['#a42b31', '#00868a'],
    yLineColors: ['#a42b31', '#00868a'],
    yValues: [
        [
            12013, 12022, 12574
        ],
        [
            12013, 12745, 12574
        ]
    ],
    yCountColor: ['#b4d8ca', '#a42b3155'],
    yCountColor2: ['#00868a', '#a42b31'],
    yCountTitle: ['# Trans. (Discovery Bay)', '# Trans. (by building)'],
    yCounts: [[10, 9, 8]],
    isError: false,
    isLoaded: false
};
exports.defaultChartPriceState3Empty = {
    yearType: ChartRangeType_1.ChartRangeType.CUSTOM,
    title: 'Custom',
    yTitle: 'Price / sqft.',
    xTitle: '',
    currentX: -1,
    active: false,
    xLabels: [],
    yLabels: [],
    yColors: [],
    yLineColors: [],
    yValues: [],
    yCountColor: [],
    yCountColor2: [],
    yCountTitle: [],
    yCounts: [],
    isError: false,
    isLoaded: false
};
exports.defaultChartPriceRangeState1 = {
    yearType: ChartRangeType_1.ChartRangeType.THREE,
    useBar: true,
    title: '3 Years',
    yTitle: 'No. of transactions',
    xTitle: '',
    currentX: -1,
    active: true,
    xLabels: ["<4M", "4-5M", "5-6M", "6-7M", "7-8M", "8-9M", "9-10M", "10-12M", "12-14M", "14-16M", "16-18M", "18-20M", "20-25M", "25-30M", "30-35M", "35-40M", "40-45M", "45-50M", "50-60M", "60-70M", "70-80M", "80-90M", "90M-100M", "100M+"],
    yLabels: ['Victoria Court'],
    yColors: ['#bc9408'],
    yLineColors: ['#bc9408'],
    yValues: [
        [
            1,
            0, 12, 8, 35, 57, 32,
            50, 39, 6, 8, 5,
            1, 3, 1, 0, 0, 0, 0, 0, 0, 0, 0,
            0
        ],
    ],
    isError: false,
    isLoaded: true
};
var defaultChartPriceRangeState2 = {
    yearType: ChartRangeType_1.ChartRangeType.ALL,
    title: "All",
    yTitle: "No. of Transaction",
    xTitle: "",
    currentX: -1,
    active: true,
    xLabels: [
        "<4",
        "4-5M",
        "5-6M",
        "6-7M",
        "7-8M",
        "8-9M",
        "9-1M",
        "10-12M",
        "12-14M",
        "14-16M",
        "16-18M",
        "18-20M",
        "20-25M",
        "25-30M",
        "30-35M",
        "35-40M",
        "40-45M",
        "45-50M",
        "50-60M",
        "60-70M",
        "70-80M",
        "80-90M",
        "90-100M",
        "100+"
    ],
    yLabels: [
        "Pak Fai Mansion"
    ],
    yColors: [
        "#bc9408"
    ],
    yLineColors: ['#bc9408'],
    yValues: [
        [
            0,
            0,
            0,
            0,
            0,
            1,
            0,
            1,
            2,
            2,
            0,
            1,
            1,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ]
    ],
    yCounts: [[]],
    yCountColor: ["#999"],
    yCountColor2: ["green"],
    useBar: true,
    yCountTitle: [""],
    isError: false,
    isLoaded: true
};
exports.defaultChartTransactionPriceRangeState1 = {
    yearType: ChartRangeType_1.ChartRangeType.THREE,
    useBar: true,
    title: '3 Years',
    yTitle: 'No. of transactions',
    xTitle: '',
    currentX: -1,
    active: true,
    xLabels: [
        '01/2016', '02/2016', '03/2016',
        '04/2016', '05/2016', '06/2016',
        '07/2016', '08/2016', '09/2016',
        '10/2016', '11/2016', '12/2016',
        '01/2017', '02/2017', '03/2017',
        '04/2017', '05/2017', '06/2017',
        '07/2017', '08/2017', '09/2017',
        '10/2017', '11/2017', '12/2017',
        '01/2018', '02/2018', '03/2018',
        '04/2018', '05/2018', '06/2018',
        '07/2018', '08/2018', '09/2018',
        '10/2018', '11/2018', '12/2018',
    ],
    yLabels: ['<8M', '8-12M', '12-16M', '16-20M', '20-30M', '30M+'],
    yColors: ['#c33306', '#fba200', '#d2d015', '#90c221', '#0680c3', '#c306b8'],
    yLineColors: ['#c33306', '#fba200', '#d2d015', '#90c221', '#0680c3', '#c306b8'],
    yValues: [
        [
            8, 5, 4, 5, 1, 3, 8, 2, 3, 1,
            3, 1, 6, 6, 7, 6, 1, 5, 6, 5,
            3, 6, 5, 5, 7, 7, 7, 2, 2, 1,
            8, 4, 6, 7, 4, 7
        ],
        [
            5, 4, 5, 1, 3, 8, 2, 3, 1, 4,
            1, 6, 6, 7, 6, 1, 5, 6, 5, 3,
            6, 5, 5, 7, 7, 7, 2, 2, 1, 3,
            4, 6, 7, 4, 7, 4
        ],
        [
            4, 5, 1, 3, 8, 2, 3, 1, 4, 4,
            6, 6, 7, 6, 1, 5, 6, 5, 3, 1,
            5, 5, 7, 7, 7, 2, 2, 1, 3, 6,
            6, 7, 4, 7, 4, 1,
        ],
        [
            8, 5, 4, 5, 1, 3, 8, 2, 3, 1,
            3, 1, 6, 6, 7, 6, 1, 5, 6, 5,
            3, 6, 5, 5, 7, 7, 7, 2, 2, 1,
            8, 4, 6, 7, 4, 7,
        ],
        [
            5, 4, 5, 1, 3, 8, 2, 3, 1, 4,
            1, 6, 6, 7, 6, 1, 5, 6, 5, 3,
            6, 5, 5, 7, 7, 7, 2, 2, 1, 3,
            4, 6, 7, 4, 7, 0
        ],
        [
            4, 5, 1, 3, 8, 2, 3, 1, 4, 4,
            6, 6, 7, 6, 1, 5, 6, 5, 3, 1,
            5, 5, 7, 7, 7, 2, 2, 1, 3, 6,
            6, 7, 4, 7, 4, 1,
        ]
    ],
    isError: false,
    isLoaded: true
};
var randomSize1 = [706, 977, 682, 653, 1152, 690, 968, 1122, 1107, 1005, 770, 658, 614, 1068, 1075, 752, 428, 1093, 728, 405, 640, 406, 436, 527, 754, 548, 473, 556, 620, 908, 625, 889, 862, 571, 426, 536];
exports.defaultChartAmountState1 = __assign(__assign({}, exports.defaultChartPriceState1), { yTitle: 'HK$(M)/sqft.', yValues: [
        exports.defaultChartPriceState1.yValues[0].map(function (it, i) { return randomSize1[i] * it; }).map(function (it) { return it / 1000000; }),
    ] });
exports.defaultChartAmountState2 = __assign(__assign({}, exports.defaultChartPriceState2), { yTitle: 'HK$(M)/sqft.', yValues: [
        exports.defaultChartPriceState2.yValues[0].map(function (it, i) { return randomSize1[i] * it; }).map(function (it) { return it / 1000000; }),
    ] });
exports.defaultChartStatePrice = [
    exports.defaultChartPriceState1Empty, exports.defaultChartPriceState2Empty,
    exports.defaultChartPriceState3Empty
];
exports.defaultChartStateAmount = [
    exports.defaultChartAmountState1, exports.defaultChartAmountState2,
];
exports.defaultChartStatePriceRange = [
    defaultChartPriceRangeState2
];
exports.defaultChartStateTransactionByPriceRange = [
    exports.defaultChartTransactionPriceRangeState1
];
